(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'emotion', 'react-router-dom', '../../styles', './VerticalNavLink'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('emotion'), require('react-router-dom'), require('../../styles'), require('./VerticalNavLink'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.emotion, global.reactRouterDom, global.styles, global.VerticalNavLink);
    global.VerticalNavItem = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _emotion, _reactRouterDom, _styles, _VerticalNavLink) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var React = _interopRequireWildcard(_react);

  var _VerticalNavLink2 = _interopRequireDefault(_VerticalNavLink);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    list-style-type: none;\n  '], ['\n    list-style-type: none;\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    border-radius: 3px;\n    border-left: 4px solid transparent;\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.03);\n    }\n  '], ['\n    border-radius: 3px;\n    border-left: 4px solid transparent;\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.03);\n    }\n  ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    border-left: 4px solid ', ';\n    font-weight: bold;\n    background-color: rgba(0, 0, 0, 0.03);\n  '], ['\n    border-left: 4px solid ', ';\n    font-weight: bold;\n    background-color: rgba(0, 0, 0, 0.03);\n  ']);

  var VerticalNavItem = function VerticalNavItem(_ref) {
    var label = _ref.label,
        path = _ref.path,
        children = _ref.children,
        location = _ref.location,
        className = _ref.className,
        testId = _ref['data-testid'];

    var isActive = (0, _reactRouterDom.matchPath)(location.pathname, { path: path, exact: true });

    return React.createElement(
      'li',
      {
        'aria-label': label,
        key: label,
        className: (0, _emotion.cx)(classNames.liReset, classNames.defaultState, isActive && classNames.activeState, className),
        'data-testid': testId
      },
      React.createElement(
        _VerticalNavLink2.default,
        { path: path },
        children
      )
    );
  };

  VerticalNavItem.defaultProps = {
    className: ''
  };

  var classNames = {
    liReset: (0, _emotion.css)(_templateObject),
    defaultState: (0, _emotion.css)(_templateObject2),
    activeState: (0, _emotion.css)(_templateObject3, _styles.colors.leaf)
  };

  exports.default = (0, _reactRouterDom.withRouter)(VerticalNavItem);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/VerticalNav/VerticalNavItem.js
// module id = 2032
// module chunks = 1